export class SkipToContent {

    private $skipToContentLink: JQuery;
    private $content: JQuery;
    private headerSelector: string;

    constructor(contentID: string, linkText: string, headerSelector: string) {

        this.$skipToContentLink = $('<a tabindex="0" class="skip-to-content" href="' + contentID + '">' + linkText + '</a>');
        $('body').prepend(this.$skipToContentLink);
        this.$content = $(contentID);
        this.headerSelector = headerSelector;

        this.$skipToContentLink.on('click', (e) => this.onSkipToContent(e));
    }

    private onSkipToContent(e: JQuery.ClickEvent) {


        if (this.$content && this.$content.length > 0) {

            e.preventDefault();

            this.$skipToContentLink.blur();

            $('html, body').stop().animate({
                'scrollTop': this.$content.offset().top - $(this.headerSelector).height()
            }, 400, 'swing', function () {

            });

            return false;
        }
    }
}